import * as stateManagement from '@/stateManagement';

export const { showUserActionNotification } =
  stateManagement.notifications.actions;
